import React from 'react';
import EditableContentMultilang from '../components/EditableContentMultilang';
import './LegalPage.css'; // Usa lo stesso CSS condiviso

const TermsConditionsPage = () => {
    return (
                    <div className="legal-page">
                <section className="page-header">
                    <div className="container">
                        <EditableContentMultilang 
                            docPath="terms_conditions_page/header" 
                            field="title" 
                            elementType="h1"
                            placeholder="Termini e Condizioni"
                        />
                    </div>
                </section>
                <section className="content-section">
                    <div className="container legal-text-container">
                        <EditableContentMultilang 
                            docPath="terms_conditions_page/content" 
                            field="main_text" 
                            elementType="textarea"
                            placeholder="[ Inserisci qui il testo completo dei Termini e Condizioni di servizio... ]"
                        />
                    </div>
                </section>
            </div>
    );
};

export default TermsConditionsPage;

